import React, { useEffect, useState } from "react";
import { formatString, handleError, formatPrice } from "../../utils/functions";
import axiosInstance from "../../config/axios.config";
import UserGaurd from "../../helper/AuthGaurd";
import ColorInit from "../../helper/ColorInit";
import ScrollToTop from "react-scroll-to-top";
import Preloader from "../../helper/Preloader";
import HeaderTwo from "../../components/HeaderTwo";
import Breadcrumb from "../../components/Breadcrumb";
import FooterTwo from "../../components/FooterTwo";
import BottomFooter from "../../components/BottomFooter";
import { useNavigate } from "react-router-dom";
import useCurrency from "../../hooks/useCurrency";
import { useTranslation } from "react-i18next";

const Orders = () => {
  const navigate = useNavigate();
  const [currency] = useCurrency();
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);
  const { t } = useTranslation();

  useEffect(() => {
    const getData = async () => {
      try {
        setIsLoading(true);
        const { data } = await axiosInstance.get("/user/order");
        if (!data.error) {
          setData(data.data);
        }
      } catch (error) {
        handleError(error);
      } finally {
        setIsLoading(false);
      }
    };
    getData();
  }, []);

  return (
    <UserGaurd>
      <ColorInit color={true} />
      {/* ScrollToTop */}
      <ScrollToTop smooth color="#FA6400" />

      {/* Preloader */}
      <Preloader isLoading={isLoading} />

      {/* HeaderTwo */}
      <HeaderTwo category={true} />

      {/* Breadcrumb */}
      <Breadcrumb title={t("myOrders")} />

      <div className="container">
          <div className="row mt-60">
            {data.map((order) => (
              <div
                className="col-12 col-md-6 mb-24 cursor-pointer"
                key={order._id}
                onClick={() => navigate(order._id)}
              >
                <div className="order-card">
                  <div className="order-card-header">
                    <h5>{t("orderNumber", { id: order._id })}</h5>
                    {order.paymentMethod !== "COD" && (
                      <span className="order-status">{t(order.paymentStatus)}</span>
                    )}
                  </div>
                  <div className="order-card-body">
                    <div className="order-details">
                      <div className="address">
                        <strong>{t("shippingAddress")}:</strong>
                        <p>{order.address.address}</p>
                        <p>
                          {order.address.city}, {order.address.state}, {order.address.country.name}{" "}
                          - {order.address.postalCode}
                        </p>
                      </div>
                      <div className="order-items">
                        <h6>{t("items")}:</h6>
                        <ul>
                          {order.items.map((item, index) => (
                            <li key={index}>
                              <strong title={item.product.name}>{formatString(item.product.name)}</strong> -{" "}
                              {item.quantity} x {formatPrice(item.price,currency)}
                              {item.color && `, ${t("color")}: ${item.color}`}
                              {item.size && `, ${t("size")}: ${item.size}`}
                            </li>
                          ))}
                        </ul>
                      </div>
                      <div className="order-summary">
                        <div className="d-flex justify-content-between">
                          <span>{t("totalAmount")}:</span> 
                          <strong className="text-black">{formatPrice(order.totalAmount, currency)}</strong>
                        </div>
                        <div className="d-flex justify-content-between">
                          <span>{t("shipmentCharges")}:</span> 
                          <strong className="text-black">{formatPrice(order.shipmentCharges, currency)}</strong>
                        </div>
                        <div className="d-flex justify-content-between">
                          <span>{t("paymentMethod")}:</span> 
                          <strong className="text-black">{t(order.paymentMethod)}</strong>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="order-card-footer">
                    <p>
                      <strong>{t("additionalInfo")}:</strong> {order.additional}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
      </div>

      {/* FooterTwo */}
      <FooterTwo />

      {/* BottomFooter */}
      <BottomFooter />
    </UserGaurd>
  );
};

export default Orders;
